import { useMemo } from 'react';

import STORAGE_KEYS from '@/configs/local-storage-keys';
import { useDatePresetFilter } from '@/features/Commons/DatePresetFilter';

export const useCommonDateState = () => {
  const { dateState, onDateFilterChange } = useDatePresetFilter({
    key: STORAGE_KEYS.COMMON_DATE_FILTER,
  });

  const dateRangeString = useMemo(() => {
    return {
      start_date: dateState.dateRange[0].toJSON(),
      end_date: dateState.dateRange[1].toJSON(),
    };
  }, [dateState.dateRange]);

  return useMemo(() => {
    return {
      dateState,
      onDateFilterChange,
      dateRangeString,
    };
  }, [dateRangeString, dateState, onDateFilterChange]);
};
